module.exports = __webpack_public_path__ + "static/media/empty-mk-history.1288e593.png";